import React from 'react';
import { get } from 'lodash';

// React view component to render
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import {memberDetailsCommunicationHistoryContactLogWidget as MemberDetailsCommunicationHistoryContactLogWidgetView  } from 'ui/views/widgets/memberDetailsCommunicationHistoryContactLogWidget';
import { MemberDetailsCommunicationHistoryContactLogWidgetService } from 'services/memberDetailsCommunicationHistoryContactLogWidget';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberDetailsCommunicationHistoryContactLogWidget } from 'ui/containers/MemberDetailsCommunicationHistoryContactLogWidget';
 *
 * // render
 * <MemberDetailsCommunicationHistoryContactLogWidget propName='propValue'/>
 */
export class MemberDetailsCommunicationHistoryContactLogWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            networkError: undefined,
            componentData: undefined,
        };

        // Member Detail instance
        this.memberDetailsCommunicationHistoryContactLogWidgetService = new MemberDetailsCommunicationHistoryContactLogWidgetService();

        // start member detail data fetch
        this.memberDetailsCommunicationHistoryContactLogWidgetData();
    }

    async memberDetailsCommunicationHistoryContactLogWidgetData() {
       
        log.debug( 'MemberDetailsCommunicationHistoryContactLogWidgetService.memberDetailsCommunicationHistoryContactLogWidgetData()' );

        // cancel ongoing request
        this.memberDetailsCommunicationHistoryContactLogWidgetService.cancel();

        try {
            const { status, data }  = await this.memberDetailsCommunicationHistoryContactLogWidgetService.fetchData( {
                url: this.props.widget.url,
                data: this.props.requestPayload,
            } );

            // check if response status was success
            if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
                    networkError: data,
                } );
            } else {
                this.setState( {
                    isFetching: false,
                    networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                    componentData: data,
                } );
            }

        } catch( e ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.memberDetailsCommunicationHistoryContactLogWidgetService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberDetailsCommunicationHistoryContactLogWidgetView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                networkError={ this.state.networkError }
                componentData={ get( this.state, 'componentData', {} ) }
                requestPayload={ this.props.requestPayload }
                errorViewConfig = { { padding: 'small' } }
            />
        );
    }
}

// set display name
MemberDetailsCommunicationHistoryContactLogWidget.displayName = 'MemberDetailsCommunicationHistoryContactLogWidget';

// set default props
MemberDetailsCommunicationHistoryContactLogWidget.defaultProps = {
    requestPayload: {},
};

// prop types
MemberDetailsCommunicationHistoryContactLogWidget.propTypes = {};
